module.exports = __webpack_public_path__ + "static/media/Support.474ef12a.jpg";